export default {
  AU: 'Australia',
  MY: 'Malaysia',
  NZ: 'New Zealand'
}